var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, Collapsible, getTestId } from '@airtel/air-design-system';
import { useEffect, useRef, useState } from 'react';
import { Keyboard, View } from 'react-native';
import { ContactDetailFormWidget } from '../contact-detail-form-widget';
import { LinkListItemWidget } from '../link-list-item-widget';
import { OmniWidget } from '../omni-widget';
import { RadioGroupWidget } from '../radio-group-widget';
import { getCommonMobilityStepCardWidgetStyles } from './CommonMobilityStepCardWidgetStyles';
import { getSubHeading } from './CommonMobilityStepCardWidgetUtils';
export var CommonMobilityStepCardWidgetComponent = props => {
  var _a;
  var _props$stepperVariant = props.stepperVariant,
    stepperVariant = _props$stepperVariant === void 0 ? 'RADIO' : _props$stepperVariant,
    _props$linkListItemPr = props.linkListItemProps,
    linkListItemProps = _props$linkListItemPr === void 0 ? {} : _props$linkListItemPr,
    _props$isExpanded = props.isExpanded,
    isExpanded = _props$isExpanded === void 0 ? false : _props$isExpanded,
    _props$initialOpen = props.initialOpen,
    initialOpen = _props$initialOpen === void 0 ? false : _props$initialOpen,
    _props$removeOverflow = props.removeOverflow,
    removeOverflow = _props$removeOverflow === void 0 ? false : _props$removeOverflow,
    _onUserAction = props.onUserAction,
    onListItemPress = props.onListItemPress,
    onToggleMetaData = props.onToggleMetaData,
    id = props.id,
    _props$disableToggle = props.disableToggle,
    disableToggle = _props$disableToggle === void 0 ? false : _props$disableToggle,
    collapsedCardHeader = props.collapsedCardHeader,
    style = props.style,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'CommonMobilityStepCardWidget' : _props$testID,
    showSubHeadingFromProps = props.showSubHeadingFromProps,
    restProps = __rest(props, ["stepperVariant", "linkListItemProps", "isExpanded", "initialOpen", "removeOverflow", "onUserAction", "onListItemPress", "onToggleMetaData", "id", "disableToggle", "collapsedCardHeader", "style", "testID", "showSubHeadingFromProps"]);
  var _useState = useState(isExpanded),
    internalIsExpanded = _useState[0],
    setInternalIsExpanded = _useState[1];
  var commonMobilityStepCardWidgetStyles = getCommonMobilityStepCardWidgetStyles(internalIsExpanded);
  var _useState2 = useState(showSubHeadingFromProps ? (_a = props === null || props === void 0 ? void 0 : props.linkListItemProps) === null || _a === void 0 ? void 0 : _a.subHeading : ''),
    subHeading = _useState2[0],
    setSubHeading = _useState2[1];
  var _useState3 = useState(restProps === null || restProps === void 0 ? void 0 : restProps.checkedRadioId),
    checkedRadioId = _useState3[0],
    setCheckedRadioId = _useState3[1];
  var collapsibleTogglerRef = useRef();
  useEffect(() => {
    var _a;
    (_a = collapsibleTogglerRef === null || collapsibleTogglerRef === void 0 ? void 0 : collapsibleTogglerRef.current) === null || _a === void 0 ? void 0 : _a.toggle(isExpanded);
    setInternalIsExpanded(isExpanded);
  }, [isExpanded]);
  useEffect(() => {
    if (!internalIsExpanded) {
      Keyboard === null || Keyboard === void 0 ? void 0 : Keyboard.dismiss();
    }
  }, [internalIsExpanded]);
  useEffect(() => {
    if (stepperVariant === 'OMNI' && showSubHeadingFromProps && !isExpanded) setSubHeading(linkListItemProps === null || linkListItemProps === void 0 ? void 0 : linkListItemProps.subHeading);
  }, [linkListItemProps === null || linkListItemProps === void 0 ? void 0 : linkListItemProps.subHeading]);
  var collapsibleHeaderHandler = () => {
    var _a;
    if (!disableToggle) {
      (_a = collapsibleTogglerRef === null || collapsibleTogglerRef === void 0 ? void 0 : collapsibleTogglerRef.current) === null || _a === void 0 ? void 0 : _a.toggle();
    }
  };
  var onCollapsibleToggleHandler = state => {
    onToggleMetaData && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
      id
    }, onToggleMetaData), {
      isExpanded: state
    }));
    setInternalIsExpanded(state);
  };
  var handleCardSubmitHandler = data => {
    if (showSubHeadingFromProps) return;
    var updatedSubHeading = getSubHeading(data, 'FORM');
    setSubHeading(updatedSubHeading);
  };
  var onRadioSelectionHandler = data => {
    setCheckedRadioId(data === null || data === void 0 ? void 0 : data.id);
    var updatedSubHeading = getSubHeading(data, 'RADIO');
    setSubHeading(updatedSubHeading);
  };
  var hasRestProps = restProps && Object.keys(restProps).length > 0;
  return _jsx(Card, Object.assign({
    style: [commonMobilityStepCardWidgetStyles.stepCard, style],
    noHorizontalPadding: true
  }, getTestId(testID), {
    children: _jsxs(Collapsible, Object.assign({
      showIcon: false,
      removeOverflow: removeOverflow,
      titleNoHorizontalPadding: true,
      titleNoVerticalPadding: true,
      childNoVerticalPadding: true,
      childNoHorizontalPadding: stepperVariant == 'OMNI',
      initialOpen: initialOpen
    }, getTestId(testID, 'collapsible'), {
      titleComponent: _jsx(LinkListItemWidget, Object.assign({}, linkListItemProps, {
        actionTypeOnPressMetaData: linkListItemProps.actionTypeOnPressMetaData
      }, getTestId(testID, 'collapsibleHeader'), {
        noHoverEffect: true,
        noPressEffect: true,
        actionTypeProps: !internalIsExpanded && (!!subHeading || stepperVariant == 'OMNI') && (linkListItemProps === null || linkListItemProps === void 0 ? void 0 : linkListItemProps.actionTypeProps),
        heading: !internalIsExpanded && subHeading && collapsedCardHeader ? collapsedCardHeader : linkListItemProps === null || linkListItemProps === void 0 ? void 0 : linkListItemProps.heading,
        subHeading: showSubHeadingFromProps ? subHeading : !internalIsExpanded && subHeading,
        onPress: onListItemPress,
        style: commonMobilityStepCardWidgetStyles.linkListWidget,
        onUserAction: (action, data) => {
          action && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
            id
          }, action), data));
          collapsibleHeaderHandler();
        }
      })),
      collapseContainerStyles: commonMobilityStepCardWidgetStyles.collapsibleContainer,
      ref: collapsibleTogglerRef,
      onToggleHandler: onCollapsibleToggleHandler
    }, {
      children: [stepperVariant == 'FORM' && hasRestProps && _jsx(ContactDetailFormWidget, Object.assign({}, restProps, getTestId(testID, 'form'), {
        onSubmit: handleCardSubmitHandler,
        onUserAction: _onUserAction
      })), stepperVariant == 'RADIO' && hasRestProps && _jsx(RadioGroupWidget, Object.assign({
        style: commonMobilityStepCardWidgetStyles.radioGroupWidgetTopMargin
      }, restProps, getTestId(testID, 'radio'), {
        checkedRadioId: checkedRadioId,
        onSelectionHandler: onRadioSelectionHandler,
        onUserAction: _onUserAction
      })), stepperVariant == 'OMNI' && hasRestProps && _jsx(View, Object.assign({
        style: commonMobilityStepCardWidgetStyles.omniWidgetTopMargin
      }, {
        children: _jsx(OmniWidget, Object.assign({}, restProps, getTestId(testID, 'omni'), {
          onUserAction: _onUserAction
        }))
      }))]
    }))
  }));
};
CommonMobilityStepCardWidgetComponent.genericRendererKey = 'AirCommonMobilityStepCardWidget';